import { createFileRoute } from "@tanstack/react-router";
import WhatIsTmsTherapyPage from "@/pages/learn/WhatIsTmsTherapyPage";
import { page2 } from "@/pages/learn/learnDataP2";
export const Route = createFileRoute(
  "/learn/what-is-tms-therapy-for-depression",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "What Is TMS Therapy for Depression? | Neuro Wellness",
        },
        {
          name: "description",
          content:
            "Learn how TMS therapy works for depression, who may qualify, treatment timelines, side effects, FDA clearance, and what patients can expect.",
        },
        {
          property: "og:title",
          content: "What Is TMS Therapy for Depression? | Neuro Wellness",
        },
        {
          property: "og:description",
          content:
            "Learn how TMS therapy works for depression, who may qualify, treatment timelines, side effects, FDA clearance, and what patients can expect.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/learn/what-is-tms-therapy-for-depression",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/learn/what-is-tms-therapy-for-depression",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(page2.schemaJson),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <WhatIsTmsTherapyPage />;
}
